// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:56:45

export default {
  "id": "sniper-3d-zombie",
  "slug": "sniper-3d-zombie",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d1a1e4c3d8d640358dd534fd79859577-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d1a1e4c3d8d640358dd534fd79859577/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sniper 3D Zombie",
      "description": "Defend your position from the zombie invasion. You have a sniper rifle, find and eliminate zombies. Hitting a zombie is not difficult, it is much more difficult to detect it. The enemies are cunning and very well disguised, they are able to blend in with the environment. Shoot the zombies and take the first places in the leaderboard!\n\n",
      "instructions": "PC control: Mouse – camera control The left mouse button is an attack The right mouse button is aiming TAB – pause/settings Control on a mobile device: All the specified buttons and joystick are displayed on the device screen.",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "3d",
        "sniper",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "《3D狙击手僵尸》",
      "description": "防御你的阵地，抵御僵尸入侵。你有一把狙击步枪，寻找并消灭僵尸。击中僵尸并不困难，但检测到它们则更为困难。敌人狡猾且伪装得非常好，能够与环境融为一体。射击僵尸，登上排行榜首位！",
      "instructions": "PC控制：鼠标 – 摄像机控制 左鼠标按钮为攻击 右鼠标按钮为瞄准 TAB – 暂停/设置 移动设备控制：所有指定的按钮和摇杆都会显示在设备屏幕上。",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "三维",
        "狙击",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "狙擊手3D僵尸",
      "description": "防禦你的位置，抵擋僵屍入侵。你有一把狙擊槍，尋找並擊敗僵屍。擊中僵屍並不困難，但發現它則要困難得多。敵人狡猾且伪装得很好，能夠与环境融為一體。射擊僵屍，奪得排行榜第一名！",
      "instructions": "PC控制：滑鼠 – 相機控制 鼠標左鍵為攻擊 鼠標右鍵為瞄准 TAB – 暫停/設定 在移動裝置上的控制：所有指定的按鈕和方向盤都會顯示在裝置螢幕上。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "3D",
        "狙擊",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "狙擊3D 僵尸",
      "description": "抵禦僵尸入侵，守護你的位置。你有一把狙擊槍，尋找並消滅僵尸。擊中僵尸並不困難，但發現它則難得多。敵人狡猾且裝扮得非常巧妙，能夠融入環境中。射擊僵尸，奪取排行榜首位！",
      "instructions": "PC控制：滑鼠 – 相機控制 雙腳滑鼠鍵為攻擊 右腳滑鼠鍵為瞄准\nTAB – 暫停/設定\n移動裝置控制：所有指定的按鈕和方向盤均會顯示在裝置螢幕上。",
      "genres": [
        "隨意",
        "射擊"
      ],
      "tags": [
        "3D",
        "狙擊",
        "僵屍"
      ]
    },
    "ja": {
      "title": "スナイパー3Dゾンビ",
      "description": "ゾンビの侵攻からあなたの位置を守れ。狙撃銃を持って、ゾンビを見つけ、排除せよ。ゾンビを撃つことは難しくないが、それを検知することは非常に難しい。敵は狡猾で非常によく偽装しており、環境に溶け込むことができる。ゾンビを撃ち、リーダーボードの上位に登場せよ！",
      "instructions": "PCコントロール：マウス - カメラ操作 左クリックボタンは攻撃 右クリックボタンは照準TAB - ポーズ/設定 モバイルデバイスのコントロール：指定されたすべてのボタンとジョイスティックがデバイスのスクリーン上に表示されます。",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "3D",
        "スナイパー",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "스나이퍼 3D 죽은자",
      "description": "저의 위치를 졸지 공격으로부터 지키세요. 스나이퍼 레이플을 들고, 졸지를 찾아 없애세요. 졸지를 맞추는 것은 어렵지 않지만, 졸지를 감지하는 것은 훨씬 더 어렵습니다. 적들은 치기가 뛰어나고 매우 잘 가장된ed, 그들은 환경에 잘 녹아들 수 있습니다. 졸지를 쏘고 랭킹 보드에서 최상위에 올라가세요!",
      "instructions": "PC 조종: 마우스 – 카메라 조종 왼쪽 마우스 버튼은 공격 오른쪽 마우스 버튼은 정확도 조정TAB – 일시정지/설정 모바일 기기 조종: 모든 지정된 버튼과 조이스틱이 기기 화면에 표시됩니다.",
      "genres": [
        "캐주얼",
        "쏘샷"
      ],
      "tags": [
        "3D",
        "스나이퍼",
        "죽은자"
      ]
    },
    "fr": {
      "title": "Sniper 3D Zombies",
      "description": "Défendez votre position contre l'invasion de zombies. Vous avez un fusil d'assaut, trouvez et éliminez les zombies. Toucher un zombie n'est pas difficile, il est beaucoup plus difficile de le détecter. Les ennemis sont rusés et très bien dissimulés, ils sont capables de se fondre dans l'environnement. Tirez sur les zombies et montez en haut du classement!",
      "instructions": "Contrôle sur PC : Souris – contrôle de la caméra Le bouton gauche de la souris est un attaque Le bouton droit de la souris est l'alignement TAB – pause/réglages Contrôle sur un appareil mobile : Tous les boutons et le manette spécifiés sont affichés sur l'écran de l'appareil.",
      "genres": [
        "C Casual",
        "Tirs"
      ],
      "tags": [
        "3D",
        "tireur d'élite",
        "zombie"
      ]
    }
  }
};
